// Open external links in new tabs
var links = document.links;
for (let i = 0; i < links.length ; i++) {
  var linkHostName = links[i].hostname;
  if (linkHostName && linkHostName !== window.location.hostname) {
    links[i].target = '_blank';
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const menuDrawerElement = document.getElementById('menu-drawer')

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        menuDrawerElement.classList.add('submenu-opened')
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const menuDrawerElement = document.getElementById('menu-drawer')
    detailsElement.classList.remove('menu-opening');

    menuDrawerElement.classList.remove('submenu-opened')

    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (!this.getAttribute('loaded')) {
        poster.addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.slideSelectorParent = this.querySelector('.slide-selectors');
    this.slideSelectors = this.querySelectorAll('.slide-selector');
    this.sortableSlides = this.querySelectorAll('li[data-image-index][data-option1]');

    this.initSlideSelectors();
    this.sortSlides();
    this.initVariantChangeListener();

    document.addEventListener('afterVariantQueryUpdate', this.triggerVariantSelect)

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    if (!this.slider || !this.nextButton) return;

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  sortSlides() {
    if(this.sortableSlides.length) {
      let sortableSlidesArr = Array.from(this.sortableSlides)
      sortableSlidesArr.sort((a, b) => {
        if(a.dataset.option1 == b.dataset.option1) {
          return parseInt(b.dataset.imageIndex) - parseInt(a.dataset.imageIndex);
        }
        return b.dataset.option1.localeCompare(a.dataset.option1);
      });

      sortableSlidesArr.forEach((el) => {
        this.slider.prepend(el);
      });
    }
  }

  triggerVariantSelect() {
    let variantRadio = document.querySelector('variant-radios')
    if(variantRadio) variantRadio.dispatchEvent(new Event('change'))
  }

  initSlideSelectors() {
    if(!this.slideSelectors.length) return;

    for( let slideSelector of this.slideSelectors ) {
      slideSelector.addEventListener('click', this.slideSelectorClick.bind(this))
    }
  }

  initVariantChangeListener() {
    document.addEventListener("colorChanged", (e) => {
      // Update selected color display if applicable
      const colorLabel = e.detail.color.toLowerCase();
      const selectedColorEl = document.getElementsByClassName('selected-color');
      if (selectedColorEl && selectedColorEl[0]) selectedColorEl[0].innerHTML = colorLabel;

      // Update variant images
      const color = e.detail.color.replace(/(\s+|\/)/g, '-').toLowerCase()
      const allThumbs = this.querySelectorAll('.product__media-item')
      const optionThumbs = this.querySelectorAll(`.product__media-item[data-option1="${color}"]`)
      const selectorsToDisplay = optionThumbs.length ? optionThumbs.length : allThumbs.length

      if (optionThumbs.length) {
        for (let thumb of allThumbs) {
          thumb.style.display = 'none';
        }

        for (let thumbIndex = 0, len = optionThumbs.length; thumbIndex < len; thumbIndex++) {
          optionThumbs[thumbIndex].style.display = "inline-block";
          if (thumbIndex == 0) {
            optionThumbs[thumbIndex].style.width = "100%";
          }
        }
      } else {
        for (let thumb of allThumbs) {
          thumb.style.display = 'inline-block';
        }
      }

      this.initPages();
      this.showFirstNSelectors(selectorsToDisplay);
      this.setActiveSelector();
      this.displaySelectors();
      this.displaySlides();
      this.updatePromoMsg(e.detail.color);
      this.slider.scrollTo({ left: 0 });
    })
  }

  showFirstNSelectors(n) {
    if(n === 0) n = this.slideSelectors.length;

    for (let selectorIndex = 0, len = this.slideSelectors.length; selectorIndex < len; selectorIndex++) {
      let displayValue = selectorIndex < n ? 'inline-block' : 'none';
      this.slideSelectors[selectorIndex].style.display = displayValue;
    }
  }

  displaySlides() {
    this.slider.classList.add('display');
  }

  displaySelectors() {
    this.slideSelectorParent.classList.add('display')
  }

  slideSelectorClick(event) {
    let slideToNavigate = event.target.dataset.slide;

    const slideScrollPosition = slideToNavigate * this.sliderLastItem.clientWidth;
    this.slider.scrollTo({ left: slideScrollPosition, behavior: "smooth" });

    this.setActiveSelector(slideToNavigate)
  }

  setActiveSelector(slideIndex) {
    if(typeof slideIndex == 'undefined') slideIndex = 0;

    for( let slideSelector of this.slideSelectors ) {
      slideSelector.classList.remove('active')
    }

    this.slideSelectors[slideIndex].classList.add('active')
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0 && element.style.display != 'none');
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if(this.slideSelectors.length) {
      this.setActiveSelector(this.currentPage - 1)
    }

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  updatePromoMsg(getColorLabel){
      this.promoData = this.getPromoMessageData(getColorLabel);
      if(this.promoData){
        const [type, message, targetElem, colors] = this.promoData;
        localStorage.setItem("typeClass", type);
        localStorage.setItem("promoData", JSON.stringify(this.promoData));
      }
  }

  getPromoMessageData(getColorLabel){
    if(typeof promoDetailsJson !== 'undefined'){
      this.promoMsgData = this.promoMsgData || promoDetailsJson;
      const getLabel = getColorLabel;
      const bodyStyle = getComputedStyle(document.body);
      const redColor = bodyStyle.getPropertyValue('--pdp-discount-red');
      const blueColor = bodyStyle.getPropertyValue('--sr-blue');
      const promoTxtTarget = document.querySelector('.product__promo');
      const selectedOption = this.promoMsgData[getLabel];
      
      let discountType = selectedOption.discountType;
      let minPrice = parseFloat(selectedOption.minPrice);
      let maxPrice = parseFloat(selectedOption.maxPrice);

      if(discountType == 'Full Price'){
        discountType = 'Full-Price';
      }

      if((discountType == 'Clearance' || discountType == 'Non-clearance') && !minPrice && !maxPrice){
        discountType = 'Full-Price';
      }

      const colors = [redColor, blueColor];
      const options = [discountType, selectedOption.discountMessage, promoTxtTarget, colors];
      //console.log(this.promoMsgData);
      return options;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent);
    this.initOptionValues();

    // Need to wait for DOM content as input selections and data updates
    // depend on other web components to be loaded first.
    document.addEventListener("DOMContentLoaded", this.updateBasedOnQueryParam.bind(this));
    document.addEventListener("VariantAutoselected", (event) => {
      // Prevent duplicate events
      if(window.lastAutoSelected != event.timeStamp) {
        window.lastAutoSelected = event.timeStamp;
        const thisElement = this.getComponentSelector();
        
        /* Reset the 'this' keyword to reflect how the product information section 
            has been changed by the Size Range Variant Change event
        */
        this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent);
        this.variantData = JSON.parse(thisElement.querySelector('[type="application/json"]').textContent);
        this.dataset.section = thisElement.dataset.section;
        this.stickyHeader = document.querySelector('sticky-header');
        this.initOptionValues();
        const fieldsets = Array.from(thisElement.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
        });
        this.onVariantChange();
      }
    });
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '');
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.emitColorData();
    this.computeOutOfStockState();
    this.finalSaleUpdate();
    this.variantInventoryCallout();
    if (!this.currentVariant) {
      this.updatePrice();
      this.toggleAddButton(true, '');
      this.setUnavailable();
    } else {
      this.recalculateLoyaltyPoints();
      this.enableWishlist();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateWishlist();
    }
  }
  
  variantInventoryCallout() {
    if(this.currentVariant) {
      //Find the info about the variant thats currently selected
      const variantData = JSON.parse(document.querySelector('#additionalVariantData').textContent);
      const matchingVariant = variantData[this.currentVariant.id];
      const matchingVariantInventoryNumber = matchingVariant?.inventory;
      const variantCalloutAmount = window.Resources.product.inventoryCalloutAmount;

      let inventoryCallout = "";
      let inventoryAmount = "";

      if(document.querySelector(".inventory__callout-message")) {
        inventoryCallout = document.querySelector(".inventory__callout-message");
        inventoryAmount = inventoryCallout.querySelector(".inventory__callout-amount");
      }

      //Check inventory number against number set in the schema settings
      if(matchingVariantInventoryNumber && matchingVariantInventoryNumber <= variantCalloutAmount && matchingVariantInventoryNumber > 0) {
        
        //Assign the empty <span> looking for current variant inventory number
        inventoryAmount.innerHTML = matchingVariantInventoryNumber;

        //Remove the opacity to reveal the element now thats its populated with all the information
        if(inventoryCallout.classList.contains("inventory__callout-message--opacity")) {
          inventoryCallout.classList.remove("inventory__callout-message--opacity");
        }
      } else {
        //Re-hide if the changed variant has an inventory greater or zero
        if(!inventoryCallout.classList.contains("inventory__callout-message--opacity")) {
          inventoryCallout.classList.add("inventory__callout-message--opacity");
        }
      }
    }
  }

  getLoyaltyRate() {
    if(loyaltylion?.ui) {
      return this.loyaltyPointsRate || loyaltylion?.ui?.priceForProductManager?.store?.getState().program?.rules?.find(rule => rule.kind == "purchase" && !rule.deactivated).value || 5;
    }
  }

  recalculateLoyaltyPoints() {
    const loyaltyPointsContainer = document.querySelector('.calculated-loyalty-points');
    const points = Math.ceil(this.currentVariant.price / 100) * this.getLoyaltyRate();
    loyaltyPointsContainer.innerHTML = points;
  }

  // Update the price based on option 1 in the event a variant is not yet selected
  updatePrice() {
    const variantData = this.getVariantData();

    if (this.options[0]) {
      const matchingColorVariant = variantData.find(variant => variant.option1 === this.options[0]);

      if (matchingColorVariant) {
        fetch(`${this.additionalVariantData[matchingColorVariant.id].url}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            // Update price display
            const id = `price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            const promoDiv = document.querySelector('div.product__promo');
            let typeClass = localStorage.getItem("typeClass") ? localStorage.getItem("typeClass") : 'noType' ;
            promoDiv.textContent = '';
            
            // Recalculate Loyalty Points
            const loyaltyPointsContainer = document.querySelector('.calculated-loyalty-points');
            const points = Math.ceil(matchingColorVariant.price / 100) * this.getLoyaltyRate();
            loyaltyPointsContainer.innerHTML = points;
            
            if (source && destination){
              destination.innerHTML = source.innerHTML;
              destination.querySelector('.price').classList.add(typeClass);
              const [type, message, targetElem, colors, minPrice, maxPrice] = JSON.parse(localStorage.getItem('promoData'));
              
              if(message !== "") {
                promoDiv.style.color = colors[1]; //blueColor
                promoDiv.textContent = message;
              } else {
                promoDiv.style.color = '';
                promoDiv.textContent = '';
              }
            } 
    
            const price = document.getElementById(`price-${this.dataset.section}`);
          
            if (price) price.classList.remove('visibility-hidden');

        });
      }
    }
  }

  finalSaleUpdate() { 
    setTimeout(function () {
      let formatedPrice = document.querySelector('.price-item').textContent.replace(/^\s+|\s+$/gm,'').substring(1);
      let priceCheck = Number(formatedPrice);
      let finalSale = document.querySelector('.product__final-sale-wrapper');

      if(finalSale) {
        if (priceCheck > 20 ) {
          finalSale.classList.add("final-sale-hidden")
        } else {
          finalSale.classList.remove("final-sale-hidden")
        }
      }
    
    }, 1200); 

    let detailsModal = document.querySelector('.product__final-sale-wrapper details')
    let detailsLabel = document.querySelector('.final_sale_details')

    if(detailsLabel) { 
      detailsLabel.addEventListener('click', function() {
        if(detailsModal.hasAttribute('open')) {
          detailsLabel.innerText = "See more details"
        } else {
          detailsLabel.innerText = "See less details"
        }  
      })
   }
  }

  initOptionValues() {
    // Implemented in Variant Radios
  }

  computeOutOfStockState() {
    // Implemented in Variant Radios
  }

  emitColorData() {
    // Implemented in Variant Radios
    // TODO - support this for select dropdowns and general options if desired by later clients
  }

  updateBasedOnQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const queryVariantID = urlParams.get('variant');

    if (queryVariantID) {
      const queryVariant = this.additionalVariantData[queryVariantID];

      if (queryVariant) {
        // Auto-select all inputs based on query variant option values
        for (const optionName in queryVariant.options) {
          const selectForOptionValue = this.querySelector(`select[name="options[${optionName}]"]`);

          if (selectForOptionValue) {
            const option = selectForOptionValue.querySelector(`option[value="${queryVariant.options[optionName]}"]`)

            if (option) {
              option.selected = 'selected';
            } else {
              console.warn(`Select option for option ${optionName} value ${queryVariant.options[optionName]} not found.`);
            }
          } else {
            console.warn(`Select element for option ${optionName} not found.`);
          }
        }

        // Trigger updates of pricing and media now that inputs are updated
        this.onVariantChange();
      } else {
        console.warn(`Variant ID ${queryVariantID} from query param not found in variantData`);
      }
    }

    document.dispatchEvent(new Event('afterVariantQueryUpdate'))
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const url = window.location.search;
    const urlParams = new URLSearchParams(url);
    urlParams.delete('variant')
    const finalParams = urlParams.toString() ? `&${urlParams.toString()}` : '';
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}${finalParams}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateWishlist() {
    if (window.wishlistAsyncInit) {
      wishlistAsyncInit();
    }

    const wishlistEl = document.querySelector('.iWishAdd');

    if (wishlistEl) {
      const selectedVariantId = this.currentVariant.id.toString()
      const selectedVariantData = this.additionalVariantData[selectedVariantId];
      const parentId = selectedVariantData.parentId;

      // Update the wishlist product id be to the correct sibling product's id
      wishlistEl.dataset.product = parentId;

      /*
       * Update the wishlist message based on whether the variant is wishlisted.
       * This uses some functions and variables initialized by the app's SDK.
       */
      if (window.isInWishlist) {
        if (window.isInWishlist(parentId, selectedVariantId)) {
          wishlistEl.innerHTML = iwish_added_txt;
          wishlistEl.classList.add('iwishAdded');
        } else {
          wishlistEl.innerHTML = iwish_add_txt;
          wishlistEl.classList.remove('iwishAdded');
        }
      }
    }
  }

  disableWishlist() {
    const wishlistEl = document.querySelector('.iwishAddWrap');
    if (wishlistEl) {
      wishlistEl.classList.add('disabled')
    }
  }

  enableWishlist() {
    const wishlistEl = document.querySelector('.iwishAddWrap');
    if (wishlistEl) {
      wishlistEl.classList.remove('disabled')
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    // additionalVariantData is initialized in main-product.liquid based on aggregated sibling group data.
    fetch(`${this.additionalVariantData[this.currentVariant.id].url}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // Update price display
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        let typeClass = localStorage.getItem("typeClass") ? localStorage.getItem("typeClass") : 'noType' ;
        if (source && destination) {
          destination.querySelector('.price').classList.add(typeClass);
        }

        // Update add to cart
        const ctaLabel = this.isMissingSelections() ? window.variantStrings.selectOptions : window.variantStrings.soldOut;
        this.toggleAddButton(!this.currentVariant || !this.currentVariant.available, ctaLabel);
      });
  }

  toggleAddButton(disable = true, text) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }
  }

  setUnavailable() {
    const isMissingSelections = this.isMissingSelections();
    if (isMissingSelections) {
      this.disableWishlist();
    }
    const ctaLabel = isMissingSelections ? window.variantStrings.selectOptions : window.variantStrings.unavailable;
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = ctaLabel;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  isMissingSelections() {
    const missingOption1 = !!(this.option1Values?.length > 1 && !this.options[0]);
    const missingOption2 = !!(this.option2Values?.length > 1 && !this.options[1]);
    const missingOption3 = !!(this.option3Values?.length > 1 && !this.options[2]);

    return missingOption1 || missingOption2 || missingOption3;
  }

  getComponentSelector() {
    return document.querySelector('variant-selects');
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.emitColorData();
  }

  initOptionValues() {
    const variants = this.getVariantData();
    this.option1Values = Array.from(new Set(variants.map((v) => v.option1)));
    this.option2Values = Array.from(new Set(variants.map((v) => v.option2)));
    this.option3Values = Array.from(new Set(variants.map((v) => v.option3)));
    
    this.option1Elements = this.getComponentSelector().querySelectorAll('fieldset[data-option-number="1"] input');
    this.option2Elements = this.getComponentSelector().querySelectorAll('fieldset[data-option-number="2"] input');
    this.option3Elements = this.getComponentSelector().querySelectorAll('fieldset[data-option-number="3"] input');
  }

  computeOutOfStockState() {
    const option1UnavailableVals = [];
    const option2UnavailableVals = [];
    const option3UnavailableVals = [];

    this.option1Values.forEach((val1) => {
      if (
        !this.variantData
          .filter(
            (variant) =>
              variant.option1 === val1
              && (this.options[1] === undefined || variant.option2 === this.options[1])
              && (this.options[2] === undefined || variant.option3 === this.options[2])
          )
          .some((variant) => variant.available)
      ) {
        option1UnavailableVals.push(val1);
      }
    });
  
    this.option2Values.forEach((val2) => {
      if (
        !this.variantData
          .filter(
            (variant) =>
              variant.option2 === val2 
              && (this.options[0] === undefined || variant.option1 === this.options[0]) 
              && (this.options[2] === undefined || variant.option3 === this.options[2])
          )
          .some((variant) => variant.available)
      ) {
        option2UnavailableVals.push(val2);
      }
    });

    this.option3Values.forEach((val3) => {
      if (
        !this.variantData
          .filter(
            (variant) =>
              variant.option3 === val3 
                && (this.options[0] === undefined || variant.option1 === this.options[0]) 
                && (this.options[1] === undefined || variant.option2 === this.options[1])
          )
          .some((variant) => variant.available)
      ) {
        option3UnavailableVals.push(val3);
      }
    });

    this.option1Elements?.forEach(el => {
      if (option1UnavailableVals.includes(el.value)) {
        el.classList.add('unavailable')
      } else {
        el.classList.remove('unavailable')
      }
    })

    this.option2Elements?.forEach(el => {
      if (option2UnavailableVals.includes(el.value)) {
        el.classList.add('unavailable')
      } else {
        el.classList.remove('unavailable')
      }
    })

    this.option3Elements?.forEach(el => {
      if (option3UnavailableVals.includes(el.value)) {
        el.classList.add('unavailable')
      } else {
        el.classList.remove('unavailable')
      }
    })
  }

  emitColorData() {
    const colorInputs = Array.from(this.getComponentSelector().querySelectorAll("input[name='Color']"));

    if (colorInputs.length) {
      const selectedInput = colorInputs.find(input => input.checked)
      if (selectedInput) {
        document.dispatchEvent(new CustomEvent('colorChanged',{
          detail: {
            color: selectedInput.value
          }
        }))
      }
    }
  }

  updateBasedOnQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const queryVariantID = urlParams.get('variant');
    const color = urlParams.get('color');

    if (queryVariantID) {
      const queryVariant = this.additionalVariantData[queryVariantID];

      if (queryVariant) {
        // Auto-select all inputs based on query variant option values
        for (const optionName in queryVariant.options) {
          const inputForOptionValue = this.querySelector(`input[name="${optionName}"][value="${queryVariant.options[optionName]}"]`);

          if (inputForOptionValue) {
            inputForOptionValue.checked = true;
          } else {
            console.warn(`Input for option ${optionName} value ${queryVariant.options[optionName]} not found.`);
          }
        }

        // Trigger updates of pricing and media now that inputs are updated
        this.onVariantChange();
      } else {
        console.warn(`Variant ID ${queryVariantID} from query param not found in variantData`);
      }
    } else if (color) {
      const inputForOptionValue = this.querySelector(`input[name="Color"][value="${color}"]`);

      if (inputForOptionValue) {
        inputForOptionValue.checked = true;
      } else {
        console.warn(`Input for option Color, value ${color} not found.`);
      }
    }

    document.dispatchEvent(new Event('afterVariantQueryUpdate'))
  }

  updateOptions() {
    const fieldsets = Array.from(this.getComponentSelector().querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
    });
  }

  getComponentSelector() {
    return document.querySelector('variant-radios');
  }
}

customElements.define('variant-radios', VariantRadios);

class RangeSelector extends HTMLElement {
  constructor() {
    super();
    this.additionalVariantData = JSON.parse(document.getElementById('additionalVariantData').textContent);
    const radioInputs = this.querySelectorAll('input[type=radio][name="Size Range"]');
    radioInputs.forEach(radio => radio.addEventListener('change', () => {
      this.fetchMainProductHtml(radio.value)
    }))

    window.addEventListener('load', this.rerunAfterpayStyling);
  };

  fetchMainProductHtml(handle) {
    

    const colorLabelElement = document.getElementById(`selected-color-${this.dataset.section}`)
    if (colorLabelElement) colorLabelElement.innerHTML = '';

    fetch(`/products/${handle}?section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `shopify-section-${this.dataset.section}`;
      const html = this.parseResponse(responseText);
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      const calculatedLoyaltyPoints = destination.querySelector('.calculated-loyalty-points').innerHTML;      
      if (source && destination) {
        destination.innerHTML = source.innerHTML;

        let currentVariant;
        const productFormVariantIDElement = html.querySelector("[name='id']");

        if (productFormVariantIDElement) {
          const currentVariantID = productFormVariantIDElement.value;
          currentVariant = this.additionalVariantData[currentVariantID];
        }
        // Update variation selections based on previous options from other range if possible
        if(currentVariant) {
          for (const optionName in currentVariant.options) {
            const inputForOptionValue = document.querySelector(`input[name="${optionName}"][value="${currentVariant.options[optionName]}"]`);

            if (inputForOptionValue) {
              inputForOptionValue.checked = true;
            } else {
              console.warn(`Input for option ${optionName} value ${currentVariant.options[optionName]} not found.`);
            }
          }
        }

        // Loyalty lion only sends requests on page load not fetches
        destination.querySelector('.calculated-loyalty-points').innerHTML = calculatedLoyaltyPoints;

        document.dispatchEvent(new Event('VariantAutoselected', { bubbles: false }));
        this.updateUrl(handle);
        this.reinitializePotentialEarnings();
        this.reinitializeReviews();
        this.rerunAfterpayStyling();
        this.rerunModalScripts();
      }
    })
  }

  parseResponse(responseText) {
    /*
      Handles a wacky edge case observed on a handful of iOS devices.
      Occasionally parsing the response text fails and only includes the content up to the variant-radios section.
      Unbelievably this parsing operation is NOT IDEMPOTENT, leading to intermittent observation of the bug.
      This logic attempts to parse the response up three times. In practice I've never seen this need more than 2 attempts to work.
    */
    const domParser = new DOMParser();
    let html = domParser.parseFromString(responseText, 'text/html');
    const htmlIsMissingProductForm = html.getElementsByTagName('product-form').length === 0;

    if (htmlIsMissingProductForm) {
      console.warn('Failed to fully parse main section HTML. Trying again.')
      const html2 = domParser.parseFromString(responseText, 'text/html');
      const html2IsMissingProductForm = html2.getElementsByTagName('product-form').length === 0;

      if (html2IsMissingProductForm) {
        console.warn('Failed to fully parse main section HTML twice. Trying one final time.')
        const html3 = domParser.parseFromString(responseText, 'text/html');
        const html3IsMissingProductForm = html3.getElementsByTagName('product-form').length === 0;

        if (html3IsMissingProductForm) {
          console.error('Failed to parse main section HTML three times.')
        } else {
          html = html3;
        }
      } else {
        html = html2;
      }
    }

    return html;
  }

  updateUrl(handle) {
    window.history.replaceState({ }, '', `/products/${handle}`);
  }

  rerunAfterpayStyling() {
    const script = document.getElementById('afterpay-pdp');
    eval(script.innerHTML);
  }

  rerunModalScripts() {
    // If the merchant has added any scripts to their size-chart we need to run them
    // again after changing size range
    const modals = Array.from(document.getElementsByTagName('modal-dialog'));
    modals.forEach(modal => {
      const scripts =  Array.from(modal.getElementsByTagName('script'));
      scripts.forEach(script => {
        eval(script.innerHTML);
      })
    })
  }

  reinitializePotentialEarnings() {
    if (window.zrl_mi) {
      zrl_mi.on_successful_product_points_fetch();
    }
  }

  reinitializeReviews() {
    try {
      if (window.Yotpo) {
        const widget = document.getElementById('yotpo-main-widget');
        if (widget) {
          const productData = JSON.parse(document.getElementById('additionalVariantData').textContent);
          widget.dataset.productId = productData.productId;
          widget.dataset.url = productData.productUrl;
        }
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      }
    } catch (e) {
      console.error('Error reinitializing reviews: ', e)
    }
  }
}

customElements.define('range-selector', RangeSelector);

class ExclusiveAccordions extends HTMLElement {
  constructor() {
    super();
    const accordionDetails = this.querySelectorAll('.product__accordion details')

    accordionDetails.forEach((targetDetail) => {
      targetDetail.addEventListener("click", () => {
        // Close all the details that are not targetDetail.
        accordionDetails.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }

          // Scroll into view if target is now offscreen - jQuery dependent currently
          try {
            if (jQuery) {
              const bodyStyle = getComputedStyle(document.body);
              const headerHeightStr = bodyStyle.getPropertyValue('--calculated-header-height');
              const headerHeight = Number(headerHeightStr.substring(0, headerHeightStr.length - 2));

              const targetTop = $(targetDetail).offset().top;
              const scrollTop = $(window).scrollTop();

              if (targetTop - headerHeight < scrollTop) {
                $('html,body').animate({scrollTop: targetTop - headerHeight}, 400);
              }
            }
          } catch (e) {
            console.error('Could not scroll target accordion into view.')
          }
        });
      });
    });
  }
}

customElements.define('exclusive-accordions', ExclusiveAccordions);

window.addEventListener("resize", calculateHeaderHeight);
window.addEventListener("scroll", calculateHeaderHeight);
window.addEventListener('DOMContentLoaded',calculateHeaderHeight)

function calculateHeaderHeight() {
	const announcementBar = document.getElementById('shopify-section-announcement-bar')
	const header = document.getElementById('shopify-section-header')

  if (header.classList.contains("shopify-section-header-sticky")) {
    totalHeaderHeight = header.offsetHeight + 1;
  } else {
    totalHeaderHeight = announcementBar.offsetHeight + header.offsetHeight + 1;
  }

	document.documentElement.style.setProperty('--calculated-header-height', totalHeaderHeight + 'px');
}


let searchClears = document.querySelectorAll('.search__clear');

for( let searchClear of searchClears ) {
  searchClear.addEventListener('click', (e) => {
    e.preventDefault();

    let parent = searchClear.parentNode;
    let searchInput = parent.querySelector('.field__input');

    searchInput.value = '';
    searchInput.focus();
  })
}

function onNavLink(e) {
  setTimeout(
    function () {
      if (e.target.matches(":hover")) {
        this.parentElement.parentElement.querySelectorAll(".header__submenu-has-children, .no-grandchildren").forEach((headerSubmenu) => {
          headerSubmenu.classList.remove("is-open");
        });
        this.classList.add("is-open");
      }
    }.bind(this),
    200
  );
}

document.addEventListener("DOMContentLoaded", function () {
  var windowWidth = window.innerWidth;

  if (windowWidth > 990) {
    const desktopNavLinks = document.querySelectorAll(".header__submenu--left-rail.header__link-lists .header__submenu-has-children");
    const desktopNavLinksChildrenless = document.querySelectorAll(".header__submenu--left-rail.header__link-lists .no-grandchildren");
    desktopNavLinks.forEach((desktopNavLink) => desktopNavLink.addEventListener("mouseover", onNavLink));
    desktopNavLinksChildrenless.forEach((desktopNavLink) =>
      desktopNavLink.addEventListener("mouseover", (e) => {
        if (e.target.matches(":hover")) {
          e.target.parentElement.parentElement.querySelectorAll(".is-open").forEach((anyLink) => anyLink.classList.remove("is-open"));
          e.target.classList.add("is-open");
        }
      })
    );
  }
});